import { render, staticRenderFns } from "./w-listing-box.vue?vue&type=template&id=f56210b2"
import script from "./w-listing-box.vue?vue&type=script&lang=js"
export * from "./w-listing-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports